import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { MerchantBranchModel } from 'Pages/orders'

export const merchantBranchesApi = {
	getAll: async (requestParams: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<MerchantBranchModel>>(
			`${urls.orders.merchantBranches}`,
			{
				params: requestParams,
			}
		)
		return res.data
	},

	getOne: async (id: number) => {
		const res = await axiosDS().get<MerchantBranchModel>(`${urls.orders.merchantBranches}/${id}`)
		return res.data
	},

	createOne: async (data: MerchantBranchModel) => {
		const res = await axiosDS().post<MerchantBranchModel>(`${urls.orders.merchantBranches}`, {
			data,
		})
		return res.data
	},

	updateOne: async (id: number, data: MerchantBranchModel) => {
		const res = await axiosDS().patch<MerchantBranchModel>(
			`${urls.orders.merchantBranches}/${id}`,
			{ data }
		)
		return res.data
	},

	restoreOne: async (id: number) => {
		const res = await axiosDS().patch(`${urls.orders.merchantBranches}/${id}/restore`)
		return res.data
	},

	deleteOne: async (id: number) => {
		const res = await axiosDS().delete(`${urls.orders.merchantBranches}/${id}`)
		return res.data
	},

	getReport: async () => {
		const res = await axiosDS().get(`${urls.orders.report_merchant_branches}`)
		return res.data
	},
}
